import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_BENEFIT_PACK, CREATE_BENEFIT_PACK_SUCCESS, CREATE_BENEFIT_PACK_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createBenefitPack({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitPacks`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_BENEFIT_PACK_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_BENEFIT_PACK_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BENEFIT_PACK_ERROR, payload: error });
  }
}

export function* watchCreateBenefitPack() {
  yield takeEvery(CREATE_BENEFIT_PACK, createBenefitPack);
}

function* createBenefitPackSaga() {
  yield all([fork(watchCreateBenefitPack)]);
}

export default createBenefitPackSaga;
